// extracted by mini-css-extract-plugin
export default {"main_div":"Stats_main_div__ndadH","graph_div":"Stats_graph_div__9hgzG"};